export const pathDiv = "/";

export const joinToPath = (path: string, name: number | string): string =>
  path ? `${path}${pathDiv}${name}` : String(name);

export const replaceLastPathName = (path: string, name: string): string =>
  joinToPath(path.split(pathDiv).slice(0, -1).join(pathDiv), name);
